<template>
  <div class="page-container">
    <div class="page-content">
      
      <!-- Page Header -->
      <div class="page-header">
          <div class="d-flex align-items-center mb-3">
              <h1 class="text-white"><i class="mdi mdi-handshake"></i> {{ economicGroupID ? 'Editar' : 'Novo' }} tomador</h1>
              <a class="btn btn-outline-white ml-auto" @click="back()"><i class="fa fa-arrow-left"></i> <span class="d-none d-md-inline"> Voltar</span></a>
          </div>
      </div>
      
      <!-- Corpo da página -->
      <div class="page-body">
            <div class="card">
                <div class="card-body p-3 p-lg-5">
                    
                    <div class="d-flex gap-2 mb-4" v-if="!isBlocked()">
                        <button type="button" class="btn btn-outline-secondary" @click="toggleClassListBlock('openAll')"><i class="fa fa-plus mr-1"></i> Expandir todas as seções</button>
                        <button type="button" class="btn btn-outline-secondary" @click="toggleClassListBlock('closeAll')"><i class="fa fa-minus mr-1"></i> Recolher todas as seções</button>
                    </div>

                    <div id="form-cadastrar" class="row form">

                        <div class="col-12">
                            <DadosTomador
                                :economicGroupID="economicGroupID"
                                :expanded="getBlocksOpenedEconomicGroup.dados_tomador"
                                :disabled="isBlocked()"
                                :editable="true"
                                @toggleSection="toggleClassListBlock('dados_tomador')"
                            />

                            <GrupoEconomico
                                :economicGroupID="economicGroupID"
                                :expanded="getBlocksOpenedEconomicGroup.grupo_economico"
                                :disabled="isBlocked()"
                                :editable="true"
                                @toggleSection="toggleClassListBlock('grupo_economico')"
                            />

                            <Corretoras
                                :economicGroupID="economicGroupID"
                                :expanded="getBlocksOpenedEconomicGroup.corretoras"
                                :disabled="isBlocked()"
                                :editable="true"
                                @toggleSection="toggleClassListBlock('corretoras')"
                            />

                            <Documentos
                                :economicGroupID="economicGroupID"
                                :expanded="getBlocksOpenedEconomicGroup.documentos"
                                :disabled="isBlocked()"
                                :editable="true"
                                @toggleSection="toggleClassListBlock('documentos')"
                            />

                            <Observacoes
                                :economicGroupID="economicGroupID"
                                :expanded="getBlocksOpenedEconomicGroup.observacoes"
                                :disabled="isBlocked()"
                                :editable="true"
                                @toggleSection="toggleClassListBlock('observacoes')"
                            />

                            <CapacidadeMercado
                                :economicGroupID="economicGroupID"
                                :expanded="getBlocksOpenedEconomicGroup.capacidade_mercado"
                                :disabled="isBlocked()"
                                @toggleSection="toggleClassListBlock('capacidade_mercado')"
                            />

                            <Seguradoras
                                :economicGroupID="economicGroupID"
                                :disabled="isBlocked()"
                                :editable="true"
                                :expanded="getBlocksOpenedEconomicGroup.seguradoras_habilitadas"
                                @toggleSection="toggleClassListBlock('seguradoras_habilitadas')"
                                class="mb-4"
                            />

                            <Quiver
                                :economicGroupID="economicGroupID"
                                :expanded="getBlocksOpenedEconomicGroup.quiver"
                                :disabled="isBlocked()"
                                :editable="true"
                                @toggleSection="toggleClassListBlock('quiver')"
                                class="mb-5"
                            />
                        </div>

                        <!-- <div class="col-12 text-right">
                            <button type="button" class="button btn btn-link text-secondary mr-1" @click="back()"><i class="fa fa-times mr-1"></i> Cancelar</button>
                            <a class="button btn btn-primary"><i class="fa fa-check mr-1"></i> Cadastrar tomador</a>
                        </div> -->

                    </div>

                </div>
            </div>
        </div>
      
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import commomsHelperMixin from "@/mixins/commomsHelper";
import { 
    DadosTomador,
    GrupoEconomico,
    Corretoras,
    Documentos,
    CapacidadeMercado,
    Seguradoras,
    Observacoes,
    Quiver
} from '@/views/Panel/Client/Components'

export default {
  name: "client-store",
  components: {
    DadosTomador,
    GrupoEconomico,
    Corretoras,
    Documentos,
    CapacidadeMercado,
    Seguradoras,
    Observacoes,
    Quiver
  },
  mixins: [commomsHelperMixin],
  data: () => ({
    economicGroupID : null,
  }),
  created() {
    if (this.isUuid(this.getIdFromUrl())) {
      this.economicGroupID = this.getIdFromUrl();
      return;
    }
    this.toggleClassListBlock('closeAll');
    this.toggleClassListBlock('dados_tomador');
  },
  methods: {
    back() {
      this.$router.push({
        name: "list-client",
        query: { filter: true },
      });
    },
    toggleClassListBlock(el = null) {
        if (el === 'openAll') {
          this.$store.commit('SET_ALL_BLOCKS_ECONOMIC_GROUP', true)
          return
        }
        if (el === 'closeAll') {
          this.$store.commit('SET_ALL_BLOCKS_ECONOMIC_GROUP', false)
          return
        }
        this.$store.commit('TOOGLE_BLOCK_ECONOMIC_GROUP', el);
    },
    isBlocked() {
        return !this.economicGroupID;
    },
  },
  computed: {
    ...mapGetters(["getBlocksOpenedEconomicGroup"]),
  }
};
</script>

<style>
</style>
